import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {useSlotRecipe, Box, Button} from '@chakra-ui/react3'
import {RATING_MAX_STARS} from '../../constants'
import {StarIcon} from '../../leap/components/icons/index'
import {ratingsTextRecipe} from './index.recipe'

const RatingSkeleton = (props) => {
    const recipe = useSlotRecipe({recipe: ratingsTextRecipe})
    const styles = useMemo(() => recipe({}), [recipe])

    return (
        <Button unstyled css={styles.button} onClick={props.onRatingsClick}>
            {Array.from({length: RATING_MAX_STARS}).map((_, i) => (
                <Box key={i} css={styles.starContainer} data-testid="empty-star">
                    <StarIcon />
                </Box>
            ))}
        </Button>
    )
}

RatingSkeleton.propTypes = {
    onRatingsClick: PropTypes.func
}

export default RatingSkeleton
